import { makeApiCall, makeApiCallWithImages } from "../apiRequest";

export default {
  state: {
    allAdminUsers: [],
    adminUserById: null,
  },
  getters: {
    getAllAdminUsers: (state) => state.allAdminUsers,
    getAdminUserById: (state) => state.adminUserById,
  },
  actions: {
    async getAllAdminUsers({ commit }, payload) {
      const response = await makeApiCall("SubOrganizationAdmins/getAll", "POST", payload);
      if (!response?.error) {
        commit("setAllAdminUsers", response.data);
      }
      return response;
    },
    async createAdminUser({ commit }, payload) {
      const response = await makeApiCall("SubOrganizationAdmins/save", "POST", payload);
      return response;
    },
    async updateAdminUser({ commit }, payload) {
      const response = await makeApiCall("SubOrganizationAdmins/save", "POST", payload);
      return response;
    },
    async deleteAdminUser({ commit }, payload) {
      const response = await makeApiCall("SubOrganizationAdmins/delete", "DELETE", payload);
      return response;
    },
    async getAdminUserById({ commit }, id) {
      const response = await makeApiCallWithImages(
        `SubOrganizationAdmins/getById?id=${id}`,
        "GET"
      );
      if (!response?.error) {
        commit("setAdminUserById", response.data?.data ?? null);
      }
      return response;
    },
  },
  mutations: {
    setAllAdminUsers: (state, payload) => (state.allAdminUsers = payload),
    setAdminUserById: (state, payload) => (state.adminUserById = payload),
  },
};


